import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const WhyTraainEducation = () => {
  const capabilities = [
    'Onboard new staff faster and more consistently',
    'Deliver safety and emergency preparedness training',
    'Prepare staff for difficult conversations and de-escalation',
    'Improve communication with parents and community members',
    'Reduce manual training administration for HR and leadership'
  ];

  return (
    <section className="py-24 px-6 bg-gradient-to-b from-transparent to-indigo-950/20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
            A Safer, More Prepared,
            <br />
            <span className="text-cyan-400">More Unified Workforce</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-4xl mx-auto">
            Traain standardizes staff enablement across roles, schools, and departments — without adding administrative burden.
          </p>
        </div>

        <div className="max-w-3xl mx-auto mb-12">
          <p className="text-xl font-bold text-white mb-6 text-center">Districts use Traain to:</p>
          <div className="space-y-4">
            {capabilities.map((capability, index) => (
              <div
                key={index}
                className="flex items-start gap-4 p-6 rounded-xl bg-gradient-to-br from-gray-900/80 to-indigo-900/20 border border-cyan-500/30 hover:border-cyan-400/60 transition-all duration-300"
              >
                <CheckCircle2 className="w-6 h-6 text-cyan-400 flex-shrink-0 mt-1" />
                <p className="text-lg text-gray-300">{capability}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center">
          <div className="inline-block p-8 rounded-2xl bg-gradient-to-br from-cyan-900/20 to-indigo-900/30 border border-cyan-500/30">
            <p className="text-xl text-cyan-400 font-semibold">
              Traain becomes the backbone of district-wide staff readiness.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyTraainEducation;
